// extracted by mini-css-extract-plugin
module.exports = {"slider":"CustomSlider_slider__T4aIq","slick-next":"CustomSlider_slick-next__sx22V"};